import { render, staticRenderFns } from "./BaseMasterCardIcon.vue?vue&type=template&id=221a188c&scoped=true"
import script from "./BaseMasterCardIcon.vue?vue&type=script&lang=js"
export * from "./BaseMasterCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a188c",
  null
  
)

export default component.exports